import type {
  EmployeeOption,
  WorkingHoursByUser,
} from "../../../../../../../_shared/_logic/form-state"
import type {
  AppointmentCreateInit,
  AppointmentWorkOrderSource,
} from "../create-appointment-contract"

type AppointmentCreateInitInput = {
  organizationId: string
  employees: EmployeeOption[]
  workOrders?: WorkOrder[]
  properties?: Property[]
  customers?: Customer[]
  contactPoints?: ContactPoint[]
  scheduleEvents?: ScheduleEvent[]
  workingHoursByUser?: WorkingHoursByUser
  candidateEmployeeIds?: string[]
  defaultEmployeeId?: string | null
  defaultStart?: Date | null
  defaultEnd?: Date | null
  defaultFlexType?: ScheduleEventFlexType | null
  defaultStatus?: ScheduleEventStatus | null
  defaultWorkOrderId?: string | null
  defaultPropertyId?: string | null
  flexSlotMinutes?: number | null
  flexSlotsPerDay?: number | null
  allowFreeAppointment?: boolean
  allowWorkOrderSelection?: boolean
  allowNewWorkOrder?: boolean
  defaultWorkOrderSource?: AppointmentWorkOrderSource | null
  orderTypes?: OrderType[]
  defaultOrderNumber?: string | null
}

type FixedWorkOrderAppointmentInitInput = Omit<
  AppointmentCreateInitInput,
  | "workOrders"
  | "candidateEmployeeIds"
  | "defaultEmployeeId"
  | "defaultWorkOrderId"
  | "defaultPropertyId"
> & {
  workOrder: WorkOrder
  allEmployeeIds?: string[]
}

export const buildAppointmentCreateInit = ({
  organizationId,
  employees,
  workOrders = [],
  properties = [],
  customers = [],
  contactPoints = [],
  scheduleEvents = [],
  workingHoursByUser = {},
  candidateEmployeeIds = [],
  defaultEmployeeId = null,
  defaultStart = null,
  defaultEnd = null,
  defaultFlexType = "HARD",
  defaultStatus = "RESERVED",
  defaultWorkOrderId = null,
  defaultPropertyId = null,
  flexSlotMinutes = null,
  flexSlotsPerDay = null,
  allowFreeAppointment = false,
  allowWorkOrderSelection = true,
  allowNewWorkOrder,
  defaultWorkOrderSource = null,
  orderTypes = [],
  defaultOrderNumber = null,
}: AppointmentCreateInitInput): AppointmentCreateInit => ({
  organizationId,
  employees,
  workOrders,
  properties,
  customers,
  contactPoints,
  scheduleEvents,
  workingHoursByUser,
  candidateEmployeeIds,
  defaultEmployeeId,
  defaultStart,
  defaultEnd,
  defaultFlexType: defaultFlexType ?? "HARD",
  defaultStatus: defaultStatus ?? "RESERVED",
  defaultWorkOrderId,
  defaultPropertyId,
  flexSlotMinutes,
  flexSlotsPerDay,
  allowFreeAppointment,
  allowWorkOrderSelection,
  allowNewWorkOrder,
  defaultWorkOrderSource,
  orderTypes,
  defaultOrderNumber,
})

export const buildFixedWorkOrderAppointmentInit = ({
  workOrder,
  allEmployeeIds = [],
  ...input
}: FixedWorkOrderAppointmentInitInput): AppointmentCreateInit =>
  buildAppointmentCreateInit({
    ...input,
    workOrders: [workOrder],
    candidateEmployeeIds: workOrder.allowed_employee_ids?.length
      ? workOrder.allowed_employee_ids
      : allEmployeeIds,
    defaultEmployeeId: workOrder.assigned_employee_id ?? null,
    defaultWorkOrderId: workOrder.id,
    defaultPropertyId: workOrder.property_id ?? null,
  })
